import { useMediaQuery } from "react-responsive";

import { QUERY_WIDTHS } from "@utils/index";
import { BusinessType, SubmissionModel } from "@interfaces/index";
import {
  TableTdMobileSubmission,
  TableTdDesktopSubmission,
} from "@components/index";

export const TableRowSubmission = ({
  submission,
  puEnabled,
  businessType,
  disabled,
  onDetails,
}: {
  submission: SubmissionModel;
  puEnabled: boolean;
  businessType?: BusinessType;
  disabled?: boolean;
  onDetails: () => void;
}) => {
  const isMobile = useMediaQuery({ query: QUERY_WIDTHS.md });

  return isMobile ? (
    <TableTdMobileSubmission
      puEnabled={puEnabled}
      businessType={businessType}
      submission={submission}
      disabled={disabled}
      onClickRow={onDetails}
    />
  ) : (
    <TableTdDesktopSubmission
      puEnabled={puEnabled}
      submission={submission}
      disabled={disabled}
      onClickRow={onDetails}
    />
  );
};
